import { EntityTypes } from "@vzbl/integrations";
import { Spacer } from "../components/Spacer";
import { Work, WorkComponent } from "../Work";
import { TabbedWork, TabbedWorkItems } from "../components/TabbedWork";
import { generateWorkTabs } from "../components/worktabs";

export function Message(props: { entity: any }) {
  const orgId = props.entity.properties.orgId!;
  const workTabsItems: TabbedWorkItems[] = generateWorkTabs(
    orgId,
    props.entity.properties.uuid,
    [
      { entityTypes: EntityTypes.Person, label: "People" },
      { entityTypes: EntityTypes.Issue, label: "Pull Requests" },
    ]
  );
  return (
    <>
      <Work
        orgId={orgId}
        entityUuid={props.entity.properties.uuid}
        types={["Channel"]}
      >
        <WorkComponent title="Channels" />
      </Work>

      <Spacer />
      <TabbedWork title="Mentioned" items={workTabsItems} />
    </>
  );
}
